const features = [
  {
    id: 1,
    icon: 'ri-flashlight-line',
    title: '实时追踪',
    desc: '7x24小时不间断追踪全网911吃瓜最新动态，利用智能聚合算法自动抓取微博、抖音、豆瓣、知乎等平台的热门爆料内容，确保你永远站在吃瓜第一线。',
  },
  {
    id: 2,
    icon: 'ri-stack-line',
    title: '深度梳理',
    desc: '每一条重大911吃瓜事件都配有完整时间线和多角度证据链，由资深编辑团队手工梳理事件脉络，让你一次性了解前因后果，不再碎片化吃瓜。',
  },
  {
    id: 3,
    icon: 'ri-lock-line',
    title: '匿名安全',
    desc: '平台支持完全匿名投稿机制，不记录任何个人身份信息。采用端到端加密技术保护爆料人隐私，让每一位勇敢发声的人都没有后顾之忧。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="section-anchor py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1100px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">平台优势</h2>
          <p className="text-sm text-foreground-500 max-w-[600px] mx-auto">为什么选择911爆料网作为你的吃瓜第一站</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((item) => (
            <div key={item.id} className="group bg-background-50 rounded-2xl p-6 md:p-8 border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer text-center">
              <div className="w-16 h-16 mx-auto mb-5 rounded-2xl bg-primary-50 flex items-center justify-center group-hover:bg-primary-100 transition-colors">
                <i className={`${item.icon} text-primary-500 text-2xl`}></i>
              </div>
              <h3 className="text-base font-heading font-semibold text-foreground-800 mb-3">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}